module.exports = __webpack_public_path__ + "media/images/icons/twotone/close-circle-822bc4677f1dc986e5f4c61fb7d98827.svg";